export default __webpack_public_path__ + "static/media/blockchain.382a7af5.png";